import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { createOption } from '@mews-commander/ui';
import { useCommanderSelector } from '@mews-commander/utils';
import { SelectField } from '@mews-commander/legacy-form';
import { getChainOptions } from '../../selectors/settings';
import { NEW_CHAIN_VALUE } from '../../constants';

const newChainOption = createOption({ value: NEW_CHAIN_VALUE, label: <LocalizedText textKey={TextKey.NewChain} /> });

const ChainSelectField = () => {
    const chainOptions = useCommanderSelector(getChainOptions);

    return (
        <SelectField
            name="chain"
            label={<LocalizedText textKey={TextKey.Chain} />}
            required
            options={[newChainOption, ...chainOptions]}
        />
    );
};

export default ChainSelectField;
